<app-header class="navbar navbar-expand-sm flex-column" />
<router-outlet />
<app-footer class="d-flex flex-column flex-grow-1" />
